export enum EnumCompartilhamentoDeDados {
    VENDA = 0,
    CADASTRO = 1,
    TODOS = 2
}